

/**
 * Return pretty label for a fieldKey from fields list
 */
export const getLabelForKey = (
  key: string | null,
  fields: { key: string; label: string }[]
) => {
  const m = fields.find((x) => x.key === key);
  return m?.label ?? "Sort by";
};

/**
 * Build options for a given row so it only shows fields
 * not used in other rules (but include current row's field).
 */
export const buildOptionsForRow = (
  rules: { fieldKey: string | null; order: "asc" | "desc" }[],
  fields: { key: string; label: string}[],
  rowIndex: number
) => {
  const currentKey = rules[rowIndex]?.fieldKey ?? null;

  const usedKeys = new Set(
    rules
      .filter((r, i) => r.fieldKey !== null && i !== rowIndex)
      .map((r) => r.fieldKey as string)
  );

  const filtered = fields.filter(
    (f) => !usedKeys.has(f.key) || f.key === currentKey
  );

  return filtered.map((f) => ({ key: f.key, label: f.label }));
};